import { FC } from 'react';
import { Parameter } from '#advertDetail/components/parameter-list/Parameter';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import modelDetailParameterListCss from '../../assets/model-detail/model-detail-parameter-list.module.scss';

const ParameterList: FC = () => {
  const {
    advert: {
      parameterDataList,
    },
  } = useAdvertDetailContext();

  if (parameterDataList.length === 0) {
    return null;
  }

  const parameterElementList = parameterDataList.map((parameterData) => (
    <Parameter key={parameterData.type} value={parameterData.value} type={parameterData.type} />
  ));

  return (
    <div className={modelDetailParameterListCss.modelDetailParameterList}>
      {parameterElementList}
    </div>
  );
};

export { ParameterList };
